module.exports = __webpack_public_path__ + "ecdb717730d428a817a3fa42649262ec.png";